import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countSuggestionRound'
})
export class CountSuggestionRoundPipe implements PipeTransform {

  transform(value: number): string {

    if (isNaN(value) || value < 1)
      return `-`;



    if (value >= 30)
      return `más de 30`;

    // if (value < 10)
    return `${value}`;



    // return `+${Math.floor(value / 10)}0`;;
  }

}
